import React, {useState, useEffect} from "react";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import Loader from "../Chargers/Loader";
import { useNavigate } from 'react-router-dom';

const EvtorDataAnalysis = () => {
  const [stationData, setStationData] = useState([]);
  const [chargerData, setChargerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDays, setselectedDays]= useState("");
  const [selectDate, setSelectedDate] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [stationTotal, setstationTotal] = useState({});
  
  document.title = "Evtor Data Analysis";

  let navigate = useNavigate();

  const handleSelectedDays = (e) => {
    setselectedDays(e.target.value);
    setSelectedDate(""); // Clear the date input when a range is selected
    setIsInitialLoad(false); // Set initial load flag to false once a selection is made
  };

    const handleReset = (event) => {
    event.preventDefault();
     navigate(`/evtordataanalysis`);
    };
    
  
  const handleSelectedDate = (e) => {
    setSelectedDate(e.target.value);
    setselectedDays(""); // Clear days selection when a date is picked
    setIsInitialLoad(false); // Set initial load flag to false once a selection is made
  };

  const FetchStationsData = async () => {
    setLoading(true);
    let url = `${BaseURL}/dashboard/station-charger-anylytics?date_wise=${selectedDays}`;

    if (selectDate)  {
       url = `${BaseURL}/dashboard/station-charger-anylytics?from_date=${selectDate.toString()} 00:00:00&to_date=${selectDate.toString()} 23:59:59`;
    }
    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setStationData(res.data.data);
       setstationTotal(res?.data?.stationTotal)
      
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(); // Pass current page and search query to the fetch function
  }, [selectedDays, selectDate]); 
console.log("stationData", stationData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
    <div style={{ maxWidth: "100%", overflowX: "auto", marginTop: "0", position: "relative" }}>
      {/* Header */}  <div style={{ marginTop: "10px", textAlign: "right" }}>
      {(isInitialLoad || selectDate) && (
        <input
          type="date"
          value={selectDate}
          onChange={handleSelectedDate}
          id="filterSelect"
          style={{
            width: "15%",
            padding: "5px",
            borderRadius: "4px",
            fontSize: "12px",
            marginRight: "10px",
          }}
        />
      )}

      {/* Days Dropdown */}
      {(isInitialLoad || selectedDays) && (
        <select
          value={selectedDays}
          onChange={handleSelectedDays}
          id="filterSelect"
          style={{
            width: "15%",
            padding: "5px",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          {/* <option value="">Select Day</option> */}
          <option value="today">Today</option>
          <option value="last_3_days">Last 3 Days</option>
          <option value="last_7_days">Last 7 Days</option>
          <option value="last_30_days">Last 30 Days</option>
        </select>
      )}
    <button
    type="submit"
    className="btn btn-primary"
    style={{
      height: "38px", // Set the height to match the input
      padding: "0 20px", // Adjust padding for horizontal space
      borderRadius: "34px",
    }}
    onClick={handleReset}
  >
    Reset
  </button>
      </div>
      {loading ? (
  <Loader />
) : (
  stationData &&
  Object.entries(stationData).map(([stationName, stationDetails], index) => (
    <div key={index}>
      <div
        style={{
          fontWeight: "bold",
          marginBottom: "5px",
          padding: "5px",
          borderRadius: "5px",
          backgroundColor: "#f3f3f3",
        }}
      >
        <strong>{stationName}</strong>
      </div>

      {/* Table */}
      <table
  style={{
    tableLayout: "auto",
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "left",
    fontSize: "12px",
  }}
  border="1"
>
  <thead>
    <tr>
      <th style={{ fontSize: "12px" }}>IMEI Number</th>
      <th style={{ textAlign: "center", fontSize: "12px" }}>Total Transactions</th>
      <th style={{ textAlign: "center", fontSize: "12px" }}>Power Consumptions</th>
      <th style={{ textAlign: "center", fontSize: "12px" }}>
        Power Consumption Amount
      </th>
      <th style={{ textAlign: "center", fontSize: "12px" }}>
      Mettalic Property
      </th>
    </tr>
  </thead>
  <tbody>
    {stationDetails?.charger &&
      Object.entries(stationDetails.charger).map(
        ([imeiNumber, chargerDetails], chargerIndex) => (
          <tr key={chargerIndex}>
            <td>{imeiNumber}</td>
            <td style={{ textAlign: "center" }}>
              {chargerDetails?.totalTransaction || "N/A"}
            </td>
            <td style={{ textAlign: "center" }}>
              {chargerDetails?.totalPowerConsumption || "N/A"}
            </td>
            <td style={{ textAlign: "center" }}>
              {chargerDetails?.totalPowerConsumptionAmount || "N/A"}
            </td>
            <td style={{ textAlign: "center" }}>
              {chargerDetails?.charger_ion_type || "N/A"}
            </td>
          </tr>
        )
      )}
  </tbody>
  <tfoot>
    <tr style={{ fontWeight: "bold" }}>
 
    
      <td style={{ textAlign: "center" }}>Total</td>
      <td style={{ textAlign: "center" }}>
        {stationDetails?.total?.totalTransaction || "N/A"}
      </td>
      <td style={{ textAlign: "center" }}>
        {stationDetails?.total?.totalPowerConsumption || "N/A"}
      </td>
      <td style={{ textAlign: "center" }}>
        {stationDetails?.total?.totalPowerConsumptionAmount || "N/A"}
      </td>
    </tr>
  </tfoot>
</table>

      <div
        style={{
          fontWeight: "bold",
          marginBottom: "5px",
          padding: "5px",
          borderRadius: "5px",
          backgroundColor: "#f3f3f3",
        }}
      >
    </div>
      

 </div>
    ))

  
)}
   {loading ? (
<h1></h1>
) : (

<table
style={{
  tableLayout: "auto",
  width: "100%",
  // borderCollapse: "collapse",
  textAlign: "left",
  fontSize: "12px",
}}
border="1"
>

  <tfoot>
  <tr style={{ fontWeight: "bold", }}>
  <th style={{textAlign: "center",  fontSize: "12px" , width: "149px", backgroundColor: "#737B83"}}></th>
    <th style={{ textAlign: "center", fontSize: "12px",  backgroundColor: "#737B83" }}>Total Transactions</th>
    <th style={{ textAlign: "center", fontSize: "12px",  backgroundColor: "#737B83" }}>Power Consumptions</th>
    <th style={{ textAlign: "center", fontSize: "12px",  backgroundColor: "#737B83" }}> 
     Power Consumption Amount
    </th>
    <th style={{ textAlign: "center", fontSize: "12px",  backgroundColor: "#737B83" }}>Mettalic Property
  
    </th>
    </tr>
    <tr style={{ fontWeight: "bold" }}>
    <td style={{ textAlign: "center", fontSize: "12px"   }}> <h6>Total</h6></td>
    <td style={{ textAlign: "center" }}>
      {stationTotal.totalStationTransaction || "N/A"}
    </td>
    <td style={{ textAlign: "center" }}>
      {stationTotal?.totalStationPowerConsumption|| "N/A"}
    </td>
    <td style={{ textAlign: "center" }}>
      {stationTotal?.totalStationPowerConsumptionAmount|| "N/A"}
    </td>
    <td style={{ textAlign: "center" }}>
      {/* {stationTotal?.totalStationPowerConsumptionAmount|| "N/A"} */}
    </td>
  </tr>
</tfoot>
</table>
)}

    </div>
 
    </div>
    </div>
    </div>
    </div>
  );
};

export default EvtorDataAnalysis;
